/* @fflow */

import React, { Component } from 'react';
// $FlowIgnore
import FileInput from 'components/FileInput';

export default class FileInputContainer extends Component {
  // $FlowIssue https://github.com/facebook/flow/issues/850
  static propTypes = FileInput.propTypes;

  render(): React.Element {
    return (
      <FileInput {...this.props} />
    );
  }
}